import React, { useContext } from "react";
import { IOnGoingTrip } from "@types";
import Avatar from "../../Avatar/indext";
import TableChip from "../../TableChip";
import { AuthContext } from "src/providers/AuthProvider";

interface PrivateHeaderProps {
  detail?: IOnGoingTrip | null;
  user?: any;
}

export const PrivateHeader: React.FC<PrivateHeaderProps> = ({ detail, user }) => {
  const {finderDriverFleet} = useContext(AuthContext);
  const finder = finderDriverFleet?.(detail?.driverId as string);
  
  return (
    <div className="display-flex flex-direction-row align-items-center padding-x-15">
      <Avatar
        url={user?.metadata?.imageProfile?.fileUrl}
        width="width-50"
      />
      <div className="padding-x-15">
        <span className="text-bold text-size-18 text-capitalize line-height-20">{detail?.driverName}</span>
        <div className="margin-top-5">
          <TableChip
            disabledDriver={!finder}
            disabledProfile={!detail?.profileId}
            user={user}
          />
        </div>
      </div>
    </div>
  );
}